import { Badge } from '@/components/ui/badge';

export function SyncKindBadge({ kind }: { kind: string }) {
  return kind === 'organization-details' ? (
    <Badge className="bg-violet-100 text-violet-800 hover:bg-violet-100">
      Orgs & sites
    </Badge>
  ) : (
    <Badge className="bg-sky-100 text-sky-800 hover:bg-sky-100">Lignes</Badge>
  );
}

export function SyncStatusBadge({ status }: { status: string }) {
  return status === 'success' ? (
    <Badge className="bg-emerald-100 text-emerald-800 hover:bg-emerald-100">
      OK
    </Badge>
  ) : (
    <Badge className="bg-rose-100 text-rose-800 hover:bg-rose-100">KO</Badge>
  );
}
